import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function NewsletterForm() {
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!name.trim() || name.trim().length < 2) errs.name = t("home.newsletter.error_name");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) errs.email = t("home.newsletter.error_email");
    if (!consent) errs.consent = t("home.newsletter.error_consent");
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setErrors({});
    navigate("/thank_you");
  };

  const privacyLink = `/${lang}/privacy`;

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto" data-testid="newsletter-form" noValidate>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="nl-name" className="block text-xs uppercase tracking-widest text-[#4a5464] mb-1.5">{t("home.newsletter.name_label")}</label>
          <input
            id="nl-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("home.newsletter.name_placeholder")}
            className="w-full border border-[#c9c2b3] bg-white px-3.5 py-3 text-sm rounded focus:outline-none focus:border-[#0F2447]"
            data-testid="newsletter-name"
            autoComplete="name"
          />
          {errors.name && <p className="mt-1 text-xs text-[#B85D3D]" data-testid="newsletter-name-error">{errors.name}</p>}
        </div>
        <div>
          <label htmlFor="nl-email" className="block text-xs uppercase tracking-widest text-[#4a5464] mb-1.5">{t("home.newsletter.email_label")}</label>
          <input
            id="nl-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("home.newsletter.email_placeholder")}
            className="w-full border border-[#c9c2b3] bg-white px-3.5 py-3 text-sm rounded focus:outline-none focus:border-[#0F2447]"
            data-testid="newsletter-email"
            autoComplete="email"
          />
          {errors.email && <p className="mt-1 text-xs text-[#B85D3D]" data-testid="newsletter-email-error">{errors.email}</p>}
        </div>
      </div>

      <label className="mt-4 flex items-start gap-3 text-sm text-[#3d4757] cursor-pointer">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-1 h-4 w-4 accent-[#0F2447]"
          data-testid="newsletter-consent"
        />
        <span>
          {t("home.newsletter.consent")}{" "}
          <a href={privacyLink} className="text-[#B85D3D] underline">↗</a>
        </span>
      </label>
      {errors.consent && <p className="mt-1 text-xs text-[#B85D3D]" data-testid="newsletter-consent-error">{errors.consent}</p>}

      <div className="mt-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <button
          type="submit"
          className="bg-[#B85D3D] text-white px-8 py-3.5 text-sm uppercase tracking-widest rounded hover:bg-[#9c4a2f]"
          data-testid="newsletter-submit"
        >
          {t("home.newsletter.submit")}
        </button>
        <p className="text-xs text-[#5a6474]">{t("home.newsletter.note")}</p>
      </div>
    </form>
  );
}
